import { render, staticRenderFns } from "./create-holiday.vue?vue&type=template&id=8b483328&"
import script from "./create-holiday.vue?vue&type=script&lang=ts&"
export * from "./create-holiday.vue?vue&type=script&lang=ts&"
import style0 from "./create-holiday.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "create-holiday.vue"
export default component.exports